import { type Customer, type CustomerProps, mkCustomer } from './customersTypes';

export function transformCustomersToRequestData(customer: Customer | CustomerProps) {
  return {
    id: customer.id,
    clientId: customer.clientId,
    createdAt: customer.createdAt,
    firstName: customer.firstName,
    lastName: customer.lastName,
    businessName: customer.businessName,
    phoneNumber: customer.phoneNumber,
    email: customer.email,
    privateNotes: customer.privateNotes,
    isDeleted: customer.isDeleted,
    isArchived: customer.isArchived,
    address: customer.address,
    paymentInfoList: customer.paymentInfoList,
  };
}

export function transformResponseToCustomers(response?: { data?: { resources?: CustomerProps[] } } | null) {
  return response?.data?.resources?.map((data) =>
    mkCustomer({
      id: data.id,
      clientId: data.clientId,
      createdAt: data.createdAt,
      firstName: data.firstName,
      lastName: data.lastName,
      businessName: data.businessName,
      phoneNumber: data.phoneNumber,
      email: data.email,
      privateNotes: data.privateNotes,
      isDeleted: data.isDeleted,
      isArchived: data.isArchived,
      address: data.address,
      paymentInfoList: data.paymentInfoList,
    }),
  );
}
